import React from "react";
import { Link } from "react-router-dom";
import topics from "../Mainpages/Data/activitylist.jsx";
import readingData from "../Mainpages/Reading-Exercises/Data/readingcomp.jsx";
import videoData from "../Mainpages/Videos/Data/video.json"; // ✅ keep only one video import
import ScrollToTop from "../Components/ScrollToTop.jsx";
import ActivityCard from "../Components/cards/ActivityCard";
import { toCardModel } from "../Components/cards/cardModel";

const RelatedExercises = ({ currentCategory, currentLevel, currentTitle = "", limit = 3 }) => {
  // Step 1: Filter topics by category + level
  const filteredTopics = topics.filter(
    (topic) => topic.category === currentCategory && topic.level === currentLevel && topic.title
  );

  // Step 2: Find index of the current exercise
  const currentIndex = filteredTopics.findIndex((topic) => topic.title === currentTitle);

  let relatedTopics = [];

  // Step 3: If not found, show first `limit`
  if (currentIndex === -1) {
    relatedTopics = filteredTopics.slice(0, limit);
  } else {
    // Step 4: Grab next `limit` items circularly
    for (let i = 1; i <= limit; i++) {
      const nextIndex = (currentIndex + i) % filteredTopics.length;
      relatedTopics.push(filteredTopics[nextIndex]);
    }
  }

  return (
    <div className="related-exercises">
      <p>Try these activities next</p>
      <ul className="topics-list">
        {relatedTopics.map((topic) => {
          const isReading = topic.category === "reading-exercises";
          const isListening = topic.category === "listening-exercises";

          const matchingReading = isReading
            ? readingData.find((r) => r.readingcompTitle === topic.title)
            : null;
          const matchingVideo = isListening
            ? videoData.find((v) => v.title === topic.title)
            : null;

          const image = matchingReading?.image || matchingVideo?.image || topic.image;

          const destination =
            isReading && matchingReading
              ? `/reading-exercises/${matchingReading.id}`
              : isListening && matchingVideo
              ? `/listening-exercises/videos?title=${encodeURIComponent(topic.title)}`
              : `/${topic.category}/${topic.id.toLowerCase()}`;

          return (
            <li key={topic.id}>
              <ScrollToTop />
              {/* image can come from the reading/listening data rather than the
                  topic record, so it is merged in before the card model is
                  built. */}
              <ActivityCard
                {...toCardModel({ ...topic, image }, { to: destination })}
              />
            </li>
          );
        })}
      </ul>

      <div className="related-exercises-footer">
        <Link to="/#filter" className="see-all-btn">
          See all exercises
        </Link>
      </div>
    </div>
  );
};

export default RelatedExercises;
